import React, { useState, useEffect } from 'react';
import { FaCookieBite, FaTimes } from 'react-icons/fa';

// *** 1. ใส่ Google Analytics ID ของคุณตรงนี้ ***
const GA_MEASUREMENT_ID = 'G-83FQDQMG9P'; 

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('app_cookie_consent');
    
    if (consent) {
      // *** 2. ถ้าเคยยอมรับแล้ว ให้เริ่มเก็บข้อมูลทันทีที่เข้าเว็บ ***
      initializeAnalytics(); 
    } else {
      setTimeout(() => setIsVisible(true), 1000);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('app_cookie_consent', 'true');
    setIsVisible(false);
    
    // *** 3. พอกดปุ่มปุ๊บ ให้เริ่มเก็บข้อมูลทันที ***
    initializeAnalytics();
  };

  // *** ฟังก์ชันสำหรับฝัง Google Analytics ***
  const initializeAnalytics = () => {
    // ป้องกันการโหลดซ้ำ
    if (window.dataLayer) return; 

    // สร้าง Script Tag ของ Google Analytics
    const script1 = document.createElement('script');
    script1.async = true;
    script1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    document.head.appendChild(script1);

    const script2 = document.createElement('script');
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${GA_MEASUREMENT_ID}');
    `;
    document.head.appendChild(script2);
    
    console.log("Google Analytics Started!"); // เช็คใน Console ดูว่าขึ้นไหม
  };

  if (!isVisible) return null;

  return (
    <div className="cookie-banner-container">
       {/* ... (ส่วนแสดงผลเหมือนเดิม) ... */}
       <div className="cookie-content">
        <div className="cookie-icon">
          <FaCookieBite size={30} />
        </div>
        <div className="cookie-text">
          <h4>การใช้งานคุกกี้</h4>
          <p>
            เราใช้คุกกี้ รวมถึงคุกกี้จากผู้ให้บริการภายนอก เพื่อวัตถุประสงค์ในการวิเคราะห์และแสดงโฆษณาเฉพาะบุคคลตามพฤติกรรมการเรียกดูของคุณ
            คุกกี้อาจได้รับการจัดเก็บโดยขึ้นอยู่กับการตั้งค่าในเว็บเบราว์เซอร์ของคุณ คุกกี้จะได้รับการจัดเก็บต่อเมื่อคุณอนุญาตในการตั้งค่าแล้วเท่านั้น หากต้องการเพิกถอนความยินยอมของคุณทุกเมื่อและดูข้อมูลเพิ่มเติมเกี่ยวกับการใช้คุกกี้
          </p>
        </div>
      </div>
      <div className="cookie-actions">
        <button onClick={handleAccept} className="cookie-btn-accept">
          ยอมรับ
        </button>
        <button onClick={() => setIsVisible(false)} className="cookie-btn-close">
          <FaTimes />
        </button>
      </div>
    </div>
  );
};

export default CookieConsent;